import React, { FC, useEffect, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { ChevronDownIcon } from '../../../../../../../../assets/icons/index';
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
  ComboboxOptionsPortalWrapper,
} from '../../../../../../../../components/combobox/index';
import { ShareClass as ShareClassHook } from '../../../../../../../../hooks/index';
import { ShareClassValue } from '../share-class.types';

type Props = {
  className?: string;
  companyId: string;
  defaultValue: null | ShareClassValue;
  disabled?: boolean;
  setShareClass: ({ id, name }: { id: string; name: string }) => void;
  wrapperClassName?: string;
};

export const FormShareClassCombobox: FC<Props> = ({
  companyId,
  setShareClass,
  defaultValue,
  className,
  wrapperClassName,
  disabled,
}) => {
  const { shareClasses } = ShareClassHook.useShareClasses({ companyId, filter: 'all' });
  const [value, setValue] = useState<null | ShareClassValue>(null);

  useEffect(() => {
    if (!defaultValue) return;
    setValue(defaultValue);
  }, [defaultValue]);

  const inputRef = useRef<HTMLDivElement | null>(null);

  return (
    <Combobox
      as={'div'}
      className={twMerge('relative w-full min-w-[130px]', className)}
      disabled={disabled}
      onChange={(selectedId: string) => {
        const selected = shareClasses.find((sc) => sc.id === selectedId);
        if (selected) {
          const shareClassValue = { id: selected.id, name: selected.name };
          setShareClass(shareClassValue);
          setValue(shareClassValue);
        }
      }}
    >
      <div className="relative w-full" ref={inputRef}>
        <ComboboxInput
          className={'bg-gray-900'}
          icon={<ChevronDownIcon className="mt-2" />}
          onChange={() => ''}
          readOnly
          value={value ? value?.name : ''}
          wrapperClassName={twMerge('h-10', wrapperClassName)}
        />
        <ComboboxButton className="absolute left-0 top-0 z-20 h-full w-full" />
      </div>
      <ComboboxOptionsPortalWrapper anchorRef={inputRef} itemsCount={shareClasses?.length || 0}>
        <ComboboxOptions className="z-20 max-h-[150px] w-full overflow-x-hidden">
          {shareClasses.map(({ name, id }, i) => (
            <ComboboxOption key={`${name}_${i}`} value={id}>
              <span className="text-sm text-gray-700">{name}</span>
            </ComboboxOption>
          ))}
        </ComboboxOptions>
      </ComboboxOptionsPortalWrapper>
    </Combobox>
  );
};
